import React from "react";
import Game from "./components/Game/Game";
import ImagePreloader from "./components/ImagePreloader/ImagePreloader";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';   // default styles

const App = ({ store }) => {
  return (
    <div>
      <ImagePreloader />
      <Game />
      <ToastContainer
        position="top-right"            /* other spots: top‑center, bottom‑left, etc.  */
        autoClose={3000}                /* ms; 0 = sticky                                */
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        theme="dark"                    /* "light", "colored", or "dark"                 */
      />
    </div>
  );
};

export default App;
